module.exports = __webpack_public_path__ + "1cace0d84f883ddb230308454a2c0bd5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/box-empty.png
// module id = +/0N
// module chunks = 2